import gradguardConfig from 'ui/config/gradguard.config';

// Double-cast: docs resolves AppConfigInput.ui as required AppConfigRuntimeUI
// (DeepRequired colors|icons|tv), while this layer only supplies a theme partial.
// The merged runtime config still comes from Nuxt UI defaults + this overlay.
export default defineAppConfig(
  gradguardConfig as unknown as Parameters<typeof defineAppConfig>[0],
);
